import murmur from 'murmurhash-js';

angular.module('signalview.murmurHash', []).factory('murmurHash', function () {
    return function (key) {
        return murmur.murmur3(key, 1);
    };
});
